<template>
  <div class="vendor-charge-list tab-table p-2">
    <VendorChargesTable/>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import VendorChargesTable from "@/modules/vendor-charges/VendorChargesTable";

  const {mapState, mapActions} = createNamespacedHelpers('vendorCharges');
  const {mapState: mapStateInventory} = createNamespacedHelpers('inventory');

  export default {
    name: "VendorCharges",
    components: {VendorChargesTable},
    computed: {
      ...mapState({
        tableData: state => state.tableData[state.tableSource]
      }),
      ...mapStateInventory({
        inventory: state => state.view.currentInventory
      })
    },
    methods: {
      ...mapActions(['updateTableSource', 'updateTableData', 'getTableData']),
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'inventory',
        sourceUuid: this.inventory.uuid
      });
    },
    mounted() {
      this.getTableData();
    }
  }
</script>

<style lang="scss" scoped>
</style>
